export default [
  {
    path: '/service-subscriptions',
    name: 'service-subscription',
    meta: { requiresAuth: true },
    component: () => import('@/pages/service-subscription/index.vue')
  },
  {
    path: '/service-unsubscriptions',
    name: 'service-unsubscription',
    meta: { requiresAuth: true },
    component: () => import('@/pages/service-subscription/unsubscriptions.vue')
  }
]
